// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"ef44a5d7","249":"b52e3c57","345":"d5822888","668":"fa14a167","720":"8c32f38c","821":"fde0c5b4"}[chunkId] + ".chunk.css";
};